window.bug_stack = [];

export const createActionStack = (action_name, detail) => {
  const length = window.bug_stack.push({ name: action_name, detail });
  console.log(`${action_name}:: ${length - 1}`);
};
